import React from 'react';
import PropTypes from 'prop-types';
import { Switch } from '@mui/material';
import c from 'classnames';

import './_toggle.scss';

const Toggle = ({ checked, size = 'medium', onChange, className = '', disabled }) => {
  const toggleClass = c('toggle', className, size, { checked });

  return (
    <Switch
      checked={checked}
      className={toggleClass}
      disabled={disabled}
      onChange={onChange}
      classes={{
        root: toggleClass,
        switchBase: 'switchBase',
        thumb: 'thumb',
        track: 'track',
        checked: 'checked'
      }}
      disableRipple={true}
      disableFocusRipple={true}
      disableTouchRipple={true}
    />
  );
};

Toggle.propTypes = {
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  onChange: PropTypes.func,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
};

export default Toggle;